import { queryOptions } from '@tanstack/react-query'
import type { ServerConfiguration as ServerConfig } from '@mobi/api-types'
import { get } from '@core/Services/ApiService'
import { queryKeys } from '../ReactQuery/constants'

export const serverConfigQuery = queryOptions({
  queryKey: [queryKeys.serverConfig],
  queryFn: () => get<ServerConfig>({ url: '/api/config' }),
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  staleTime: 1_000 * 60 * 60, // 1hr
})
